export default "__VITE_ASSET__DuUsyDEs__"